import { motion, useReducedMotion } from "framer-motion";

// Kinetic masked line-by-line reveal on load.
export const KineticHeading = ({ lines, className = "", delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <h1 className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className="block"
            initial={reduce ? { opacity: 0 } : { y: "110%" }}
            animate={reduce ? { opacity: 1 } : { y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
};
